<template>
  <div class="panel-content-wrapper">
    <p class="title">{{ $t('app.campaign.management.customize.title') }}</p>
    <div>
      <CampaignCardEditer v-model="currentCampaign"></CampaignCardEditer>
    </div>
    <div class="edit-buttons">
      <Button class="m green" :label="$t('other.actions.confirm')" @click="updateCampaign"></Button>
      <Button class="m outline-white" :label="$t('other.actions.cancel')" @click="emits('close')"></Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from '@/components/global/Button.vue';
import { useCampaign, useEditCampaign } from '@/queries/campaigns.query';
import { useCampaignPublicInvitation, useDisablePublicInvitation, useEnablePublicInvitation } from '@/queries/invitation.query';
import { useToast } from 'vue-toastification';
import CampaignCardEditer from '@/components/campaigns/CampaignCardEditer.vue';
import { Campaign } from '@/types/campaign';

const emits = defineEmits(['close', 'save']);

const toast = useToast();
const appStore = useAppStore();

const { mutate: editCampaign } = useEditCampaign();

const props = defineProps<{
  campaign: Campaign,
}>();

const currentCampaign: Ref<Campaign> = ref(null)

onMounted(() => {
  currentCampaign.value = structuredClone(toRaw(props.campaign));
});

watch(() => props.campaign, () => {
  currentCampaign.value = structuredClone(toRaw(props.campaign));
});

function updateCampaign() {
  editCampaign({
    context: {
      organisationId: appStore.currentOrganisationId,
      spaceId: currentCampaign.value.campaign.parent_workspace_id,
      campaignId: currentCampaign.value.id,
    },
    campaign: currentCampaign.value,
  });
  emits('close');
}

</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.panel-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 1.5rem;

  .title {
    font-size: 20px;
    font-weight: 700;
  }

  .choice {
    display: flex;
    gap: 10px;
  }

  .edit-buttons {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 10px;
  }

  .radio-group {
    display: flex;
    width: 800px;
    padding-top: 10px;

    .radio-option-left {
      margin-right: 20px;
    }

    .radio-option {
      display: flex;
      align-items: top;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      cursor: pointer;
      transition: border-color 0.3s ease-in-out;
    }

    .radio-option-selected {
      border-color: #ffcc00; 
    }

    .auto-radio-button-dot {
      top: -2px;
      position: relative;
      padding: 8px;
      margin-left: 6px;
      margin-right: 12px;
      border: 2px solid #ffcc00;
    }

    input[type=radio]:checked::after {
      width: 10px;
      height: 10px;
    }

    .radio-option-title {
      margin-bottom: 5px;
    }

    .radio-option-text {
      margin: 0;
      font-size: 0.9em;
      font-style: italic;
    }
  }
}
</style>